import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Image as ImageIcon, X } from "lucide-react";

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  if (photos.length === 0) {
    return (
      <section id="gallery" className="py-24 bg-[#F9F8F6]" data-testid="gallery-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="overline text-[#E07A5F]">Memories</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3">
            Our Gallery
          </h2>
          <div className="mt-10 border-2 border-dashed border-border rounded-2xl py-16 text-[#5C6661]">
            <ImageIcon className="w-10 h-10 mx-auto opacity-40" />
            <p className="mt-3 text-sm">Gallery photos will appear here soon.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="gallery" className="py-24 bg-[#F9F8F6]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="overline text-[#E07A5F]">Memories</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3 leading-tight">
            Moments from Our Journey
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="photo-gallery">
          {photos.map((p, idx) => (
            <button
              key={p.id}
              onClick={() => setLightbox(p)}
              className="group relative aspect-square overflow-hidden rounded-xl bg-muted"
              data-testid={`gallery-item-${idx}`}
            >
              <img
                src={p.image}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3 text-left">
                <div>
                  <div className="text-white text-sm font-semibold">{p.title}</div>
                  {p.caption && <div className="text-white/80 text-xs">{p.caption}</div>}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20"
            data-testid="lightbox-close"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="max-w-4xl max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
            <img src={lightbox.image} alt={lightbox.title} className="max-w-full max-h-[80vh] rounded-xl object-contain" />
            <div className="text-center mt-4 text-white">
              <div className="font-serif-display text-xl">{lightbox.title}</div>
              {lightbox.caption && <div className="text-sm text-white/70 mt-1">{lightbox.caption}</div>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
